import React from 'react';
import { Form, Input, message, Alert } from 'antd';
import axios from 'axios';

import apiPath from 'apiPath';
import withSpin from 'components/withSpin';
import SaveButton from 'components/SaveButton';

const formItemLayout = {
	labelCol: { sm: { span: 24 }, md: { span: 10 }, lg: { span: 7 } },
	wrapperCol: { sm: { span: 24 }, md: { span: 14 }, lg: { span: 17 } },
	marginBottom: '8pt'
};

class RoommateRequests extends React.Component {
	state = {
		roommate1ID: null,
		roommate1: '',
		roommate2ID: null,
		roommate2: '',
		doubleCabin: null
	}
	makeRoommateRequest = (data) => {
		return axios.put(apiPath+'/roommate', data, {
			withCredentials: true
		}).catch(this.props.handleAxiosSaveError);
	}
	handleSubmit = (event) => {
		event.preventDefault();
		this.props.isSubmitting();
		this.props.form.validateFields((err, values) => {
			if (err) {
				this.props.isSubmitted();
				return stickyError(err.message);
			}
			this.makeRoommateRequest({
				id: this.state.roommate2ID, comments: values.roommate2
			}).then(result => {
				this.props.form.setFieldsValue({roommate2: values.roommate2});
				this.makeRoommateRequest({
					id: this.state.roommate1ID, comments: values.roommate1
				}).then(result => {
					this.props.form.setFieldsValue({roommate1: values.roommate1});
					this.props.isSubmitted();
					message.success('Saved!');
				});
			});
		});
	}
	getRoommatesFromProps = (props) => {
		if (props.remarksLoaded) {
			const matchingRemarks = props.remarks.filter(remark => remark.Code === 'ROOMMATES');
			this.setState({
				roommate1ID: (matchingRemarks[0]) ? matchingRemarks[0].AssignId : null,
				roommate1: (matchingRemarks[0]) ? matchingRemarks[0].Comments : '',
				roommate2ID: (matchingRemarks[1]) ? matchingRemarks[1].AssignId : null,
				roommate2: (matchingRemarks[1]) ? matchingRemarks[1].Comments : ''
			});
		}
		if (props.transactions.find(transaction =>
			transaction.BaseMessage.toLowerCase().indexOf('double') !== -1 &&
			transaction.BaseMessage.toLowerCase().indexOf('cabin') !== -1
		)) {
			this.setState({doubleCabin: true});
		} else {
			this.setState({doubleCabin: false});
		}
	}
	componentWillReceiveProps(nextProps) {
		this.getRoommatesFromProps(nextProps);
	}
	componentDidMount() {
		this.getRoommatesFromProps(this.props);
	}
	render() {
		const disabled = this.props.variant !== 'admin' && !this.props.sectionIsEnabled(this.props, 'cabin/roommates');
		if (this.props.variant !== 'admin') {
			const redirect = this.props.redirectIfHidden(this.props, 'personal/emergency');
			if (redirect) return redirect;
		}

		const { getFieldDecorator } = this.props.form;
		return (
			<div>
			<Alert showIcon type="info"
					message="Roommate Requests"
		description={<span>Roommate requests can only be honoured if the request is mutual (all roommate request each other) and you are in the same cabin category as your request roommate. Please enter your requested roommate’s name EXACTLY as it appears on their passport - entering nicknames, shortened names, etc. may prevent us from matching you correctly. </span>} />
		<br />
			<Form onSubmit={this.handleSubmit}>
				<Form.Item label="Requested Roommate's Full Name (#1)" {...formItemLayout}>
					{getFieldDecorator('roommate1', {
						initialValue: this.state.roommate1,
						rules: [{max: 200, message: 'Too long (max 200 characters)'}]
					})(
						<Input disabled={disabled} />
					)}
				</Form.Item>
				{this.state.doubleCabin !== true &&
					<Form.Item label="Requested Roommate's Full Name (#2)" {...formItemLayout}>
						{getFieldDecorator('roommate2', {
							initialValue: this.state.roommate2,
							rules: [{max: 200, message: 'Too long (max 200 characters)'}]
						})(
							<Input disabled={disabled} />
						)}
					</Form.Item>
				}
				<SaveButton
					disabled={!this.props.form.isFieldsTouched()}
					loading={this.props.getStatus().submitting} />
			</Form>
			</div>
		);
	}
}

export default withSpin(Form.create()(RoommateRequests));



// WEBPACK FOOTER //
// ./portal-components/Portal/Cabin/Roommate.jsx